<template>
  <div style="margin-bottom: 20px">
    <b-navbar toggleable="md" type="dark" variant="info">
      <b-container>
        <b-navbar-brand to="/"> {{ title }} </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav v-if="access_token != undefined">
            <b-nav-item-dropdown id="dropdown-1" left>
              <!-- Using 'button-content' slot -->
              <template #button-content>Problems</template>
              <b-dropdown-item to="/problem">Problems</b-dropdown-item>
              <b-dropdown-item to="/submission">Submission</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown left>
              <!-- Using 'button-content' slot -->
              <template #button-content>Debug Tools</template>
              <b-dropdown-item
                v-if="wg_reloader_enable"
                @click="
                  timer_wg();
                  $refs['generateKey'].show();
                "
                >WireGuard Key Reloader</b-dropdown-item
              >
              <b-dropdown-item
                v-for="(item, index) in debug_tools"
                :key="index"
                @click="
                  debug_tool = item;
                  debug_log = '';
                  get_debug_logs();
                  variable = '';
                  timer(item.id);
                  $refs['debug_tool'].show();
                "
                :disabled="!userinfo.isActive"
              >
                {{ item.title }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown v-if="userinfo.isAdmin" left>
              <!-- Using 'button-content' slot -->
              <template #button-content>Admin</template>
              <b-dropdown-item to="/admin/user"
                >User Management</b-dropdown-item
              >
              <b-dropdown-item to="/admin/attribute"
                >Attribute Management</b-dropdown-item
              >
              <b-dropdown-item to="/admin/score"
                >Score Management</b-dropdown-item
              >
              <b-dropdown-item to="/admin/debugtools"
                >Debug Tool Management</b-dropdown-item
              >
            </b-nav-item-dropdown>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav v-if="access_token != undefined" class="ml-auto">
            <b-nav-item-dropdown right>
              <!-- Using 'button-content' slot -->
              <template #button-content> {{ userinfo.username }}</template>
              <b-dropdown-item to="/profile">Profile</b-dropdown-item>
              <b-dropdown-item @click="logout()">Sign Out</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
          <b-navbar-nav v-else class="ml-auto">
            <b-nav-item-dropdown right>
              <!-- Using 'button-content' slot -->
              <template #button-content>Login</template>
              <b-dropdown-item @click="login(csit_oauth)"
                >CSIT OAuth</b-dropdown-item
              >
              <b-dropdown-item @click="login(nycu_oauth)"
                >NYCU OAuth</b-dropdown-item
              >
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
        <b-modal
          ref="debug_tool"
          id="debug_tool"
          hide-footer
          :title="debug_tool.title"
          size="lg"
        >
          <div class="text-center" style="font-size: 1.2rem">
            <b-input-group
              :prepend="debug_tool.title"
              class="mt-2"
              @submit="submit_debug_tools()"
            >
              <b-form-input
                v-model="variable"
                :placeholder="debug_tool.description"
                required
                :disabled="cooldown_seconds != 0 && !userinfo.isAdmin"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  variant="primary"
                  v-if="cooldown_seconds == 0"
                  @click="submit_debug_tools()"
                  :disabled="variable.length <= 0"
                  >Submit</b-button
                >
                <b-button
                  variant="primary"
                  v-else-if="userinfo.isAdmin"
                  @click="submit_debug_tools()"
                  :disabled="variable.length <= 0"
                  >Submit ({{ cooldown_seconds }})</b-button
                >
                <b-button variant="primary" v-else disabled>
                  Wait for {{ cooldown_seconds }} seconds.</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </div>
          <div
            style="
              background-color: black;
              color: white;
              font-family: 'Courier New';
              padding: 10px 10px 10px;
              border-radius: 5px;
            "
            v-html="debug_log"
            class="mt-3"
          ></div>
          <div class="col text-center">
            <b-button class="mt-3" @click="get_debug_logs()" variant="primary"
              >Refresh</b-button
            >
          </div>
        </b-modal>
        <b-modal
          ref="generateKey"
          id="generateKey"
          hide-footer
          title="WireGuard Key Reloader (Beta)"
          size=""
        >
          <p>
            This tool can help yout to generate a new WireGuard Keys Config
            without TA's help.
            <br />
            <br />
            When you click the "Generate" Button, server will generate a new
            config for you and restart wireguard server for you automated(CD: 1
            hr)
            <br />
            <br />
            If you have ever clicked "Generate" button, the keys in "Profile"
            Page would not be update and you need to get your wg0.conf form
            "Download" button everytime.
            <br />
          </p>
          <center>
            <b-row>
              <b-col>
                <b-button
                  v-if="userinfo.isAdmin"
                  variant="primary"
                  @click="requestNewKey()"
                  >Generate (CD: {{ wg_cooldown_seconds }})</b-button
                >
                <b-button
                  v-else
                  variant="primary"
                  @click="requestNewKey()"
                  :disabled="wg_button_msg != 'Generate'"
                  >{{ wg_button_msg }}</b-button
                >
              </b-col>
              <b-col>
                <b-button
                  variant="primary"
                  @click="getNewKeys()"
                  :disabled="wg_download_need_wait"
                  >{{ wg_download_msg }}</b-button
                >
              </b-col>
            </b-row>
          </center>
        </b-modal>
      </b-container>
    </b-navbar>
  </div>
</template>
<script>
import AnsiUp from "ansi_up";
var ansi_up = new AnsiUp();
export default {
  name: "navbar",
  props: {
    title: String,
    test: String,
  },
  data() {
    return {
      csit_oauth_url: process.env.VUE_APP_CSIT_OAUTH_URL,
      csit_oauth_client_id: process.env.VUE_APP_CSIT_OAUTH_CLIENTID,
      csit_oauth_redirect_url: process.env.VUE_APP_CSIT_OAUTH_REDIRECT_URL,
      csit_oauth_scope: process.env.VUE_APP_CSIT_OAUTH_SCOPE,
      csit_oauth: undefined,
      nycu_oauth_url: process.env.VUE_APP_NYCU_OAUTH_URL,
      nycu_oauth_client_id: process.env.VUE_APP_NYCU_OAUTH_CLIENTID,
      nycu_oauth_scope: process.env.VUE_APP_NYCU_OAUTH_SCOPE,
      nycu_oauth: undefined,
      access_token: undefined,
      userinfo: {
        isAdmin: false,
        username: "",
      },
      api_user: "/user/me",
      debug_tools: [],
      debug_tool: {},
      debug_log: "",
      timeInterval: 0,
      wg_timeInterval: 0,
      cooldown_seconds: 0,
      show_console: true,
      variable: "",
      priKey: undefined,
      pubKey: undefined,
      showGenerator: false,
      wg_reloader_enable: process.env.VUE_APP_WG_RELOADER_ENABLE,
      wg_cooldown_seconds: 0,
      wg_download_msg: "Download",
      wg_download_seconds: 10,
      wg_download_need_wait: false,
      wg_button_msg: "Generate",
    };
  },
  watch: {},
  computed: {
    checkEmpty() {
      return this.variable.length > 0 ? true : false;
    },
  },
  methods: {
    getNewKeys() {
      let access_token = localStorage.getItem("access_token");
      let api = "/debug/wireguard";
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          if (response.data != "Loading...") {
            const anchor = document.createElement("a");
            anchor.href =
              "data:text/plain;charset=utf-8," +
              encodeURIComponent(response.data);
            anchor.target = "_blank";
            anchor.download = "wg0.conf";
            anchor.click();
          }
        });
    },
    requestNewKey() {
      let access_token = localStorage.getItem("access_token");
      let api = "/debug/wireguard";
      let self = this;
      this.$http
        .post(
          api,
          {},
          {
            headers: {
              Authorization: "Bearer " + access_token,
            },
          }
        )
        .then(() => {
          self.timer_wg();
        });
      this.wg_download_wait();
    },
    login(oauth) {
      this.access_token = localStorage.getItem("access_token");
      this.$http
        .get(this.api_user, {
          headers: {
            Authorization: "Bearer " + this.access_token,
          },
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status == 422) {
              //console.log(error.response.status);
              location.replace(oauth);
            }
          }
        });
    },
    logout() {
      localStorage.clear();
      location.replace("/");
    },
    get_user_info() {
      let self = this;
      this.access_token = localStorage.getItem("access_token");
      this.$http
        .get(this.api_user, {
          headers: {
            Authorization: "Bearer " + this.access_token,
          },
        })
        .then((response) => {
          self.userinfo = response.data;
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status == 422) {
              self.logout();
            }
          }
        });
    },
    get_debug_tools() {
      let self = this;
      let access_token = localStorage.getItem("access_token");
      let api = "/debug/";
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          self.debug_tools = response.data.sort(function (a, b) {
            return a.id > b.id ? 1 : -1;
          });
        });
    },
    get_debug_logs() {
      let self = this;
      let access_token = localStorage.getItem("access_token");
      let api = "/debug/";
      this.$http
        .get(api + self.debug_tool.id, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          self.debug_log = ansi_up
            .ansi_to_html(response.data.log)
            .replace(/\n/gm, "<br>");
        })
        .catch(function (error) {
          if (error.response.status == 404) {
            self.debug_log = "You don't have any submitted record.";
          }
        });
    },
    submit_debug_tools() {
      let self = this;
      let access_token = localStorage.getItem("access_token");
      let api = "/debug/";
      this.debug_log = "Loading...";
      let data = {
        value: this.variable,
      };
      this.$http
        .post(api + self.debug_tool.id, data, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then(() => {
          let wait = 10;
          let timeInterval = setInterval(function () {
            if (wait != 0) {
              wait -= 1;
              self.get_debug_logs();
            } else {
              clearInterval(timeInterval);
            }
          }, 3000);
          self.timer(self.debug_tool.id);
        });
    },
    timer(id) {
      let access_token = localStorage.getItem("access_token");
      let api = "/debug/" + id + "/cooldown";
      let self = this;
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          self.cooldown_seconds = response.data.seconds;
          if (self.cooldown_seconds != 0) {
            this.timeInterval = setInterval(function () {
              if (self.cooldown_seconds != 0) {
                self.cooldown_seconds -= 1;
              } else {
                clearInterval(self.timeInterval);
              }
            }, 1000);
          }
        });
    },
    timer_wg() {
      if (this.wg_timeInterval != undefined) {
        clearInterval(this.wg_timeInterval);
      }
      let self = this;
      let access_token = localStorage.getItem("access_token");
      let api = "/debug/wireguard/cooldown";
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          self.wg_cooldown_seconds = response.data.seconds;
          //console.log(self.wg_download_seconds)
          if (self.wg_cooldown_seconds != 0) {
            self.wg_timeInterval = setInterval(function () {
              if (self.wg_cooldown_seconds != 0) {
                self.wg_button_msg =
                  "Wait for " + self.wg_cooldown_seconds + " seconds.";
                self.wg_cooldown_seconds -= 1;
              } else {
                self.wg_button_msg = "Generate";
                clearInterval(self.wg_timeInterval);
              }
            }, 1000);
          }
        });
    },
    wg_download_wait() {
      let self = this;
      let seconds = process.env.VUE_APP_WG_RELOADER_WAIT_DOWNLOAD_SECONDS;
      let wg_download_timeInterval = setInterval(function () {
        if (seconds > 0) {
          self.wg_download_need_wait = true;
          self.wg_download_msg = "Please Wait " + seconds;
          seconds -= 1;
        } else {
          self.wg_download_msg = "Download";
          self.wg_download_need_wait = false;
          clearInterval(wg_download_timeInterval);
        }
      }, 1000);
    },
  },
  beforeCreate() {},
  created() {
    this.access_token = localStorage.getItem("access_token");
    if (this.access_token != undefined) {
      this.get_user_info();
      this.get_debug_tools();
    }
    this.csit_oauth = encodeURI(
      this.csit_oauth_url +
        "?client_id=" +
        this.csit_oauth_client_id +
        "&redirect_uri=" +
        this.csit_oauth_redirect_url +
        "&response_type=code&scope=" +
        this.csit_oauth_scope
    );
    this.nycu_oauth = encodeURI(
      this.nycu_oauth_url +
        "?client_id=" +
        this.nycu_oauth_client_id +
        "&response_type=code&scope=" +
        this.nycu_oauth_scope
    );
  },
  beforeMount() {},
  mounted() {
    this.$root.$on("bv::dropdown::show", (bvEvent) => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = true;
      }
    });
    this.$root.$on("bv::dropdown::hide", (bvEvent) => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = false;
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault();
      }
    });
  },
};
</script>